import { render, staticRenderFns } from "./PaymentMethodAdded.vue?vue&type=template&id=2d987621&scoped=true"
import script from "./PaymentMethodAdded.vue?vue&type=script&lang=js"
export * from "./PaymentMethodAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d987621",
  null
  
)

export default component.exports